import { t } from '@kanbios/ui';

/** D44: the periods of the « Disponibilité » screen; « custom » takes two dates. */
export const PERIODS = ['day', 'month', 'quarter', 'year', 'custom'] as const;
export type Period = (typeof PERIODS)[number];

/** The bounds of a period as the API takes them: from its start (local time) to now, or the custom days. */
export function periodBounds(period: Period, custom: [Date | null, Date | null], now = new Date()): { from: string; to: string } | null {
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (period === 'month') start.setDate(1);
  if (period === 'quarter') start.setMonth(Math.floor(now.getMonth() / 3) * 3, 1);
  if (period === 'year') start.setMonth(0, 1);
  if (period !== 'custom') return { from: start.toISOString(), to: now.toISOString() };
  const [first, last] = custom;
  if (!first || !last) return null;
  // The last day picked is included: up to the next midnight.
  const end = new Date(last.getFullYear(), last.getMonth(), last.getDate() + 1);
  return { from: new Date(first.getFullYear(), first.getMonth(), first.getDate()).toISOString(), to: end.toISOString() };
}

/** 99,950 %: three decimals, as an availability is read (99,9 % hides 40 minutes a month). */
export const percent = (value: number, digits = 3) =>
  `${(value * 100).toLocaleString('fr-FR', { minimumFractionDigits: digits, maximumFractionDigits: digits })} %`;

/** A duration to the minute: « 0 min », « 42 min », « 3 h 05 », « 2 j 4 h ». */
export function duration(seconds: number): string {
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return t('availability.duration.minutes', { n: minutes });
  if (minutes < 24 * 60) return t('availability.duration.hours', { h: Math.floor(minutes / 60), m: String(minutes % 60).padStart(2, '0') });
  return t('availability.duration.days', { d: Math.floor(minutes / 1440), h: Math.floor((minutes % 1440) / 60) });
}
